var RemovedScoresModifier = /** @class */ (function () {
    function RemovedScoresModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    RemovedScoresModifier.prototype.modify = function (content) {
        if (content.scores === undefined) {
            return;
        }
        var scores = content.scores.remove;
        if (scores !== undefined) {
            for (var i = 0; i < scores.length; i++) {
                scores[i] = this._modelKeyRepository.removeScore(scores[i]);
            }
        }
    };
    return RemovedScoresModifier;
}());
export default RemovedScoresModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/RemovedScoresModifier.js